import { Context, Controller } from '@hotwired/stimulus';
import { toggleHidden } from 'src/utils/dom-toggle';

export default class InputController extends Controller {
  public static targets = [
    'input',
    'onBlank',
    'onAllBlank',
    'onPresent',
    'onAllPresent',
    'onValid',
    'onInvalid',
  ];

  declare private inputTargets: readonly HTMLInputElement[];

  declare private onBlankTargets: readonly HTMLElement[];
  declare private onAllBlankTargets: readonly HTMLElement[];
  declare private onPresentTargets: readonly HTMLElement[];
  declare private onAllPresentTargets: readonly HTMLElement[];
  declare private onValidTargets: readonly HTMLElement[];
  declare private onInvalidTargets: readonly HTMLElement[];

  constructor(context: Context) {
    super(context);

    this.onChange = this.onChange.bind(this);
    this.clear = this.clear.bind(this);
  }

  connect(): void {
    this.onChange();
  }

  disconnect(): void {}

  private get inputs(): HTMLInputElement[] {
    if (Array.isArray(this.inputTargets)) {
      return this.inputTargets as HTMLInputElement[];
    }

    const targets: HTMLInputElement[] = [];
    this.inputTargets.forEach((target) => targets.push(target));

    return targets;
  }

  public inputTargetConnected(target: HTMLInputElement) {
    target.addEventListener('change', this.onChange);
  }

  public inputTargetDisconnected(target: HTMLInputElement) {
    target.removeEventListener('change', this.onChange);
  }

  private onChange() {
    const anyPresent = this.inputs.some((input) => !!input.value.trim());
    const allPresent = this.inputs.every((input) => !!input.value.trim());
    const allValid = this.inputs.every((input) => input.validity.valid);

    this.onBlankTargets.forEach((target) => toggleHidden(target, allPresent));
    this.onAllBlankTargets.forEach((target) =>
      toggleHidden(target, anyPresent),
    );
    this.onPresentTargets.forEach((target) =>
      toggleHidden(target, !anyPresent),
    );
    this.onAllPresentTargets.forEach((target) =>
      toggleHidden(target, !allPresent),
    );

    this.onValidTargets.forEach((target) => toggleHidden(target, !allValid));
    this.onInvalidTargets.forEach((target) => toggleHidden(target, allValid));
  }

  public clear() {
    this.inputs.forEach((input) => (input.value = ''));

    this.onChange();
  }
}
